import { sheetScope } from "../utils/props";

export const stackScope = /*           */ sheetScope.scope("stack");

/**
 *
 *
 *
 *
 */
export const findInstance = (sheetId: string | null | undefined): HTMLOcSheetV1Element | null =>
  sheetId ? document.querySelector<HTMLOcSheetV1Element>(`#${sheetId}`) : null;

/**
 *
 *
 *
 */
export const getInstance = (sheetId: string): HTMLOcSheetV1Element =>
  findInstance(sheetId) ??
  (() => {
    throw new Error(`Sheet instance with id ${sheetId} not found in the DOM.`);
  })();
